import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from 'ngx-translate-with-country';
import { BreadcrumbsService } from 'ng6-breadcrumbs';
import { Title } from '@angular/platform-browser';
import { ContactService } from '../_services/contact.service';
import { PageService } from '../_services/page.service';
import { SimpleSmoothScrollService } from 'ng2-simple-smooth-scroll';
import { CategoryService } from '../_services/category.service';
import { LocationService } from '../_services/location.service';

declare var $: any;

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {
  country: string;
  language: string;
  id: number;
  model: any = {};
  ids = [];
  faqKeys = [];
  categoriesArray: any;
  page: any;
  newpage: any;
  faqObject: any;
  customText: any;
  faq: any;
  newFaq: any;
  new: any;
  selectedFaq: any;
  displayddl: string;
  countries: any;
  supportBanner: any;
  supportRegister: any;
  supportFind: any;
  constructor(
    private locationService: LocationService,
    private categoryService: CategoryService,
    private _contactService: ContactService,
    private translate: TranslateService,
    public titleService: Title,
    private route: ActivatedRoute,
    public breadcrumbsService: BreadcrumbsService,
    private _pageService: PageService,
    private smooth: SimpleSmoothScrollService

  ) { }

  getCustomPages(country: string, language: string) {
    this._contactService.getCustomPages(country, language)
      .subscribe(
        resJSONData => {
          this.page = resJSONData[0];
          this.supportBanner = resJSONData[0].supportBanner.path;
          this.supportRegister = resJSONData[0].supportRegister.path;
          this.supportFind = resJSONData[0].supportFind.path;

        },
        error => console.log('Error ::' + error)
      );
  }

  getValueFromSelect(value: any) {
    this.selectedFaq = value;
    this.displayddl = 'none';
  }

  getFAQs(id: number, country: string, language: string): void {
    this._pageService.getFAQs(country, language)
      .subscribe(
        resultArray => {
          this.faq = resultArray;
          this.faqKeys = Object.keys(this.faq);
        },
        error => console.log('Error ::' + error)
      );
  }

  getCategories(country: string, language: string): void {
    this.categoryService.getCategories(country, language)
      .subscribe(
        resultArray => {
          this.categoriesArray = resultArray;
        },
        error => console.log('Error ::' + error)
      );

  }

  // getLocation(countryParam: string, languageParam: string): void {
  //   this.locationService.getLocation(countryParam, languageParam).subscribe(
  //     response => {
  //       this.countries = response;
  //     },
  //     error => console.log('Error ::' + error)
  //   );
  //   console.log(this.country);
  // }

  goTop(){
    this.smooth.smoothScrollToTop({ duration: 1000, easing: 'linear' });
  }
  
  ngOnInit() {
    console.log('support')
    this.smooth.smoothScrollToAnchor();

    this.route.params
      .subscribe(
        (params: Params) => {
          this.id = +params['id'];
          this.country = params['country'];
          this.language = params['language'];
          
          this.getFAQs(this.id, this.country, this.language);
          this.getCategories(this.country, this.language);
          this.getCustomPages(this.country, this.language);
        }
      );
  }
}
